import { ReactNode, useMemo } from 'react';

export interface MainLayoutContentProps {
  children: ReactNode;
  showSidebar?: boolean;
}

const MainLayoutContent: React.FunctionComponent<MainLayoutContentProps> =
  function ({ children, showSidebar = true }) {
    const className = useMemo(
      () =>
        [
          'flex flex-col flex-1 w-full max-h-full overflow-scroll',
          showSidebar ? 'md:w-2/3 desktop:w-[calc(50%+240px)]' : '',
        ].join(' '),
      [showSidebar],
    );
    return <div className={className}>{children}</div>;
  };

export default MainLayoutContent;
